// ═══════════════════════════════════════════════════════════════════════════
// Progress — segmented pill stepper (editorial, no numeric label)
// ═══════════════════════════════════════════════════════════════════════════
export const ProgressBar = ({ step, total, accent }) => {
    return (
        <div
            className="flex items-center gap-1.5"
            data-testid="fms-preview-progress"
            role="progressbar"
            aria-valuenow={step + 1}
            aria-valuemin={1}
            aria-valuemax={total}
        >
            {Array.from({ length: total }, (_, i) => {
                const state = i < step ? "past" : i === step ? "current" : "future";
                const base = "flex-1 h-[3px] rounded-full transition-all duration-500 ease-out";
                if (state === "past") {
                    return (
                        <span
                            key={i}
                            className={base}
                            style={{ background: accent, opacity: 0.6 }}
                            data-state="past"
                        />
                    );
                }
                if (state === "current") {
                    return (
                        <span
                            key={i}
                            className={`${base} sayz-fms-progress-active`}
                            style={{ background: accent }}
                            data-state="current"
                        />
                    );
                }
                return (
                    <span
                        key={i}
                        className={base}
                        style={{ background: "hsl(var(--muted-foreground))", opacity: 0.18 }}
                        data-state="future"
                    />
                );
            })}
        </div>
    );
};
